import React from "react";
import { ShimmerEffect } from "components/ShimmerEffect";
import theme from "theme";

const CartHistoryDetailsShimmer = () => {
  const detailRows = Array.from({ length: 6 });
  const cardRows = Array.from({ length: 4 });

  return (
    <div style={{ padding: "14px 20px" }}>
      <ShimmerEffect width="150px" height="16px" />
      <div
        style={{
          border: `1px solid ${theme.colors.bordertask}`,
          borderRadius: "8px",
          overflow: "hidden",
          marginBottom: "20px",
        }}
      >
        {detailRows.map((_, index) => (
          <div
            key={index}
            style={{
              display: "grid",
              gridTemplateColumns: "160px 1fr",
              alignItems: "center",
              padding: "11px 14px",
              borderBottom:
                index === detailRows.length - 1
                  ? "none"
                  : `1px solid ${theme.colors.bordertask}`,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <ShimmerEffect width="16px" height="16px" />
              <ShimmerEffect width="95px" height="14px" />
            </div>
            <ShimmerEffect
              width={index % 2 === 0 ? "72%" : "48%"}
              height="14px"
            />
          </div>
        ))}
      </div>

      {["LINKED OCCUPANTS", "FILES", "DOWNLOAD HISTORY"].map((section) => (
        <div key={section} style={{ marginTop: "18px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginBottom: "10px",
            }}
          >
            <ShimmerEffect width="130px" height="15px" />
            <ShimmerEffect width="28px" height="16px" />
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                section === "DOWNLOAD HISTORY" ? "1fr" : "1fr 1fr",
              gap: "8px",
            }}
          >
            {cardRows.map((_, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  padding: "10px 14px",
                  border: `1px solid ${theme.colors.bordertask}`,
                  borderRadius: "8px",
                }}
              >
                <ShimmerEffect
                  width={section === "DOWNLOAD HISTORY" ? "34px" : "18px"}
                  height={section === "DOWNLOAD HISTORY" ? "34px" : "18px"}
                />
                <div style={{ flex: 1 }}>
                  <ShimmerEffect width="85%" height="13px" />
                  {section === "FILES" && (
                    <ShimmerEffect width="65%" height="11px" />
                  )}
                </div>
                <ShimmerEffect width="64px" height="18px" />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CartHistoryDetailsShimmer;
